import { render, staticRenderFns } from "./addOrder.vue?vue&type=template&id=16990f22&scoped=true"
import script from "./addOrder.vue?vue&type=script&lang=ts"
export * from "./addOrder.vue?vue&type=script&lang=ts"
import style0 from "./addOrder.vue?vue&type=style&index=0&id=16990f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16990f22",
  null
  
)

export default component.exports